<a *ngIf="isUserLoggedIn()" tabindex="0" (keyup.enter)="openModal();" (click)="openModal();"><!-- {{"copy.label.LOGOUT.logout"|copy|async}} --><i class="fas fa-sign-out-alt" aria-label="Log out"></i></a>
